import { NOTIFICATION_DISPLAYED, NOTIFICATION_HIDDEN } from '../constants';

const INITIAL_STATE = [];

export const actionsMap = {
    [NOTIFICATION_DISPLAYED]: (state, action) => {
        return [...state, action.payload];
    },
    [NOTIFICATION_HIDDEN]: (state, action) => {
        return state.filter(
            notif => notif.id.toString() !== action.payload.id.toString()
        );
    },
};

export default function sagaNotifications(state = INITIAL_STATE, action) {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/middleware/notifications/reducers/index.js